import { Flex } from "@chakra-ui/react";
import { Glossary, TabComponent, RuleTab, NextPageButton } from "../components";

const Rules = () => {
  return (
    <Flex flex="1" direction="column" p={"10px 35px 35px 35px"}>
      <TabComponent
        isFitted={true}
        tab1="Rules"
        tab2="Glossary"
        tab1Content={<RuleTab />}
        tab2Content={<Glossary />}
      />
      <NextPageButton to="/strategy" label="Strategy" />
    </Flex>
  );
};
export default Rules;
